export default __webpack_public_path__ + "static/media/banner-profile-stats.6ffe47e5.jpg";